import axiosInstance from "@/boot/axios";
class ShareRepository {
    constructor() {
        this.path = "/v1/share";
    }

    async getShare(id) {
        const response = await axiosInstance.get(`${this.path}/${id}`);
        return response.data;
    }
}

export default new ShareRepository();
